import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import useCurrentCourse from '@src/hooks/useCurrentCourse';
import { isFundraisingRefund } from '@src/utils/course';

const TeacherSaidWrapper = styled.div`
	padding: ${props => (props.isFundraisingRefund ? '16px 20px' : 0)};
	border: ${props => (props.isFundraisingRefund ? '1px solid #DDDDDD;' : 'none')};
	border-radius: 8px;
	margin-top: 16px;
	min-height: 80px;

	@media ${props => props.theme.device.tablet} {
		width: ${props => (props.isFundraisingRefund ? '460px' : '100%')};
	}

	@media ${props => props.theme.device.smTablet} {
		width: ${props => (props.isFundraisingRefund ? '460px' : '100%')};
		margin-top: ${props => (props.isFundraisingRefund ? '24px' : '16px')};
	}
`;

const Content = styled.div`
	display: -webkit-box;
	margin-top: 4px;
	text-overflow: ellipsis;
	overflow: hidden;
	-webkit-line-clamp: ${props => (props.isFundraisingRefund ? 'none' : 3)};
	-webkit-box-orient: vertical;
	font-size: 14px;

	@media ${props => props.theme.device.mobile} {
		-webkit-line-clamp: 4;
	}
`;

const TeacherSaid = (): JSX.Element => {
	const { t } = useTranslation();
	const { currentCourse: { status, highlights } } = useCurrentCourse();

	return (
		<TeacherSaidWrapper isFundraisingRefund={isFundraisingRefund(status)}>
			<Content isFundraisingRefund={isFundraisingRefund(status)}>
				{isFundraisingRefund(status) ? t('course:teacher_said_description_default') : highlights}
			</Content>
		</TeacherSaidWrapper>
	);
};

export default TeacherSaid;
